export enum EnumStockRequestStatus {
  DELIVERED_FULL = 'Complete',
  DELIVERED_INCOMPLETE = 'Incomplete',
  REQUEST = 'Requested',
}
